import Modal from 'react-modal';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import { RouteOneFinanceSource } from '@upstart/harmony/lib/legos/routeOneTypes';
import React, { useState } from 'react';
import { FinanceType, FNIType } from '@upstart/harmony/lib/constants';
import { useAsync } from 'react-async-hook';
import { FniTypeName } from '@upstart/harmony/lib/legos/constants';
import Input from '../Input';
import DealerService from '../../../services/DealerService';
import { scrollableModalStyles } from '../../../util/constants';
import './FinanceSourcesModal.scss';

interface FinanceSourcesModalProps {
  dealer: Dealer;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (financeSources: RouteOneFinanceSource[]) => void;
  financeType: FinanceType;
}

const FinanceSourcesModal = ({
  dealer,
  isOpen,
  onClose,
  onSubmit,
  financeType,
}: FinanceSourcesModalProps) => {
  const financeSources = useAsync<RouteOneFinanceSource[]>(
    DealerService.getFinanceSources,
    [dealer, financeType],
  );

  const [selectedFinanceSources, setSelectedFinanceSources] = useState<
    RouteOneFinanceSource[]
  >([]);

  const toggleFinanceSource = (financeSource: RouteOneFinanceSource) => {
    const isSelected = selectedFinanceSources.find(
      fs => fs.fsId === financeSource.fsId,
    );
    if (isSelected) {
      setSelectedFinanceSources(
        selectedFinanceSources.filter(fs => fs?.fsId !== financeSource.fsId),
      );
    } else {
      setSelectedFinanceSources([...selectedFinanceSources, financeSource]);
    }
  };

  const fniType = dealer.fniType
    ? FniTypeName[dealer.fniType as FNIType]
    : null;

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Finance Sources Modal"
      style={scrollableModalStyles as any}
      ariaHideApp={false}
    >
      <div className="finance-sources-container">
        <h3>Select Banks to Submit Financing</h3>
        <div className="finance-sources-rows">
          {(financeSources.result?.length === 0 || financeSources.error) &&
            fniType && (
              <div>
                <p>
                  No finance sources have been configured for manual submission
                  in {fniType}, or the finance sources have failed to load.
                </p>
                <p>
                  Clicking submit will send the application to {fniType} where
                  you can continue with the submission from there.
                </p>
              </div>
            )}
          {financeSources.result?.map(financeSource => (
            <div className="finance-sources-row" key={financeSource.fsId}>
              <div>
                <Input
                  data-testid={`checkbox-${financeSource.fsId}`}
                  type="checkbox"
                  onChange={() => toggleFinanceSource(financeSource)}
                />
              </div>
              <div>{financeSource.name}</div>
            </div>
          ))}
        </div>
        <div className="finance-sources-buttons">
          <button
            className="modal-button secondary cc-button-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            data-testid="submit-button"
            className="modal-button cc-button-primary"
            onClick={() => onSubmit(selectedFinanceSources)}
          >
            Submit to lenders
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FinanceSourcesModal;
